import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="text-xl font-bold">Suscríbete</h3>
            <p className="text-gray-300 text-sm">
              Regístrate con tu dirección de correo electrónico para recibir
              noticias y actualizaciones
            </p>
            <form className="space-y-2">
              <input
                type="email"
                placeholder="Correo electrónico"
                className="w-full px-4 py-2 rounded bg-gray-800 text-white"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 bg-blue-900 text-white rounded hover:bg-blue-800"
              >
                Suscribir
              </button>
            </form>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Mapa del sitio</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-gray-300 hover:text-white"
                >
                  Servicios
                </Link>
              </li>
              <li>
                <Link
                  to="/nuestro-equipo"
                  className="text-gray-300 hover:text-white"
                >
                  Nuestro Equipo
                </Link>
              </li>
              <li>
                <Link
                  to="/publicaciones"
                  className="text-gray-300 hover:text-white"
                >
                  Publicaciones
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-300 hover:text-white">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Servicios</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/servicios"
                  className="text-gray-300 hover:text-white"
                >
                  Sistema de Derechos Humanos
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-gray-300 hover:text-white"
                >
                  Derecho Constitucional
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-gray-300 hover:text-white"
                >
                  Derecho Penal
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-gray-300 hover:text-white"
                >
                  Derecho Disciplinario
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-gray-300 hover:text-white"
                >
                  Reclamos Administrativos
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contacto</h3>
            <address className="text-gray-300 not-italic">
              <p>Cartagena, Colombia</p>
              <p>Email: T-DEFENDEMOS@outlook.com</p>
              <p>Tel: +57 (310) 275-8946</p>
            </address>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} T-Defendemos. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
